<script setup lang="ts">
import { ForgotPasswordForm } from '~/components/auth/forms/forgot-password';
import ForgotPasswordPage from '~/utils/contents/auth/pages/ForgotPasswordPage';

definePageMeta({ layout: 'onboarding', auth: false });

useHead({
  title: ForgotPasswordPage.seo.title,
});
</script>

<template>
  <div
    class="forgot-password-page flex items-start justify-center px-4 md:px-0"
  >
    <ForgotPasswordForm data-testid="forgot-password-form" />
  </div>
</template>

<style lang="scss" scoped>
.forgot-password-page {
  padding-top: 40px;
  width: 100%;

  @media (min-width: 768px) {
    padding-top: 128px;
  }
}
</style>
